import React, { FC } from 'react';
import { BigBlock } from 'store/landing/types';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './BigBlockGroup.module.scss';

export interface BigBlockGroupProps {
  blocks: BigBlock[];
}

const BigBlockGroup: FC<BigBlockGroupProps> = ({ blocks }) => {
  const { theme, isDesktopDevice } = useLandingPageContext();

  const getImageUrl = (block: BigBlock) => (isDesktopDevice ? block.imageUrlDesktop : block.imageUrlMobile);

  return (
    <div className={(styles.container, styles[`theme-${theme}`])}>
      <div className={styles.wrapper}>
        {blocks.map((block) => (
          <div className={styles.item} key={block.entryId}>
            <a href={block.referenceUrl} className={styles.banner}>
              <img className={styles.banner__image} src={getImageUrl(block)} alt={block.title} />
              <div className={styles.banner__titles}>
                {block.referenceLabel && (
                  <>
                    <h2 className={styles.name} style={{ color: block.titleColor }}>
                      {block.title}
                    </h2>
                    {isDesktopDevice && (
                      <span className={cn(styles.description, styles.text)} style={{ color: block.descriptionColor }}>
                        {block.description}
                      </span>
                    )}
                    <span className={cn(styles.url, styles.text)}>
                      <span className={styles.link} style={{ color: block.referenceLabelColor }}>
                        {block.referenceLabel}
                        <span className={cn(styles.op_icon, styles.op_icon_arrow_left)} />
                      </span>
                    </span>
                  </>
                )}
                {!block.referenceLabel && (
                  <h2
                    className={styles.banner__titles__nameUrl}
                    style={{ color: block.titleColor, borderBottomColor: block.titleColor }}
                  >
                    {block.title}
                  </h2>
                )}
              </div>
              {block.discount && (
                <div
                  className={styles.banner__discount}
                  style={{
                    color: block.discount.fontColor,
                    backgroundColor: block.discount.bubbleBackgroundColor,
                    borderColor: block.discount.bubbleBorderColor,
                  }}
                >
                  {block.discount.label}
                </div>
              )}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BigBlockGroup;
